class FAQs extends HTMLElement {
    constructor() {
        super();

        this.filter = document.getElementById('haloFAQsFilter');
        this.faqsPopup = document.getElementById('halo-faqs-popup');

        if (this.filter) {
            this.filterToggle = this.filter.querySelector('[data-faqs-filter]');
            this.filterDropdown = this.filter.querySelector('.faqs-filterDropdown-menu');
            this.filterDropdownArrow = this.filterToggle ? this.filterToggle.querySelector('[data-dropdown-arrow]') : null;

            if (this.filterToggle) {
                this.filterToggle.addEventListener('click', this.onClickFilterHandler.bind(this));
            }

            if (this.filterDropdown) {
                this.filterDropdown.querySelectorAll('.text').forEach((filterButton) => {
                    filterButton.addEventListener('click', this.onClickFilterButtonHandler.bind(this));
                });
            }
        }

        if (this.querySelector('.faqs')) {
            this.querySelectorAll('.card-header').forEach((headerButton) => {
                headerButton.addEventListener('click', this.onClickHeaderButtonHandler.bind(this));
            });
        }

        if (!document.body.classList.contains('template-index')) {
            document.body.addEventListener('click', this.onBodyClickEvent.bind(this));
        }
    }

    // Handles dropdown toggle functionality
    onClickFilterHandler() {
        if (this.filterDropdown.classList.contains('is-show')) {
            this.filterDropdown.classList.remove('is-show');
            if (this.filterDropdownArrow) {
                this.filterDropdownArrow.classList.remove('active');
            }
        } else {
            this.filterDropdown.classList.add('is-show');
            if (this.filterDropdownArrow) {
                this.filterDropdownArrow.classList.add('active');
            }
        }
    }

    // Handles filter click to scroll to the relevant FAQ section
    onClickFilterButtonHandler(event) {
        const btn = event.target.closest('li');

        if (!btn.classList.contains('is-active')) {
            const filterValue = btn.getAttribute('data-value');
            const filterText = event.target.innerText;

            // Update active filter text if dropdown is used
            if (this.filterToggle) {
                this.filterToggle.querySelector('.text').innerText = filterText;
            }

            // Highlight the active filter
            this.filterDropdown.querySelectorAll('li').forEach((element) => {
                element.classList.remove('is-active');
            });

            btn.classList.add('is-active');

            // Scroll to the corresponding FAQ section ensuring heading and FAQs are visible
            if (filterValue) {
                const targetSection = document.getElementById(filterValue);
                if (targetSection) {
                    // Get the section's top position
                    const sectionTop = targetSection.getBoundingClientRect().top + window.scrollY;

                    // Adjust for header offset and scroll smoothly
                    const offset = 200; // Adjust based on your header height
                    window.scrollTo({
                        top: sectionTop - offset,
                        behavior: 'smooth',
                    });
                }
            }

            // Close dropdown if applicable
            if (this.filterDropdown.classList.contains('is-show')) {
                this.filterDropdown.classList.remove('is-show');
                if (this.filterDropdownArrow) {
                    this.filterDropdownArrow.classList.remove('active');
                }
            }
        }
    }

    // Handles FAQ expand/collapse functionality
    onClickHeaderButtonHandler(event) {
        const btn = event.currentTarget;
        const content = btn.nextElementSibling;

        btn.classList.toggle('collapsed');

        if (content.style.maxHeight) {
            content.style.maxHeight = null;
        } else {
            content.style.maxHeight = content.scrollHeight + 'px';
        }
    }

    // Closes the dropdown if clicking outside
    onBodyClickEvent(event) {
        if (event.target.closest('[data-faqs-filter]') != null) return;

        if (this.filterDropdown && this.filterDropdown.classList.contains('is-show')) {
            this.filterDropdown.classList.remove('is-show');
            if (this.filterDropdownArrow) {
                this.filterDropdownArrow.classList.remove('active');
            }
        }
    }
}

// Define the custom element
customElements.define('faqs-item', FAQs);
